export const getItemAndRestInArray = <T>(
  items: T[],
  predicate: (item: T) => boolean,
): { foundItem: T | undefined; restItems: T[] } => {
  let foundItem;
  const restItems = [];
  for (let index = 0; index < items.length; index += 1) {
    const item = items[index];
    const found = predicate(item);
    if (found) foundItem = item;
    else restItems.push(item);
  }
  return { foundItem, restItems };
};

export const appendIf = <T>(predicate: boolean | ((item: T) => boolean), item: T): T[] => {
  return (typeof predicate === 'function' && predicate(item)) || !!predicate ? [item] : [];
};
